// $(document).ready(function () {
//     let uploadProgress = []
//     let finishedUploads = []
//     let numberOfFiles = []
//     let progressBar = document.getElementById('progress-bar')
//
//     // Get all elements with class uploadButton and add event listener
//     document.querySelectorAll('.uploadButton').forEach(uploadButton => {
//         uploadButton.addEventListener('change', handleSelection, false)
//     });
//
//     function hideDropZone() {
//         let dropzone = document.getElementById("dropzone");
//         dropzone.style.display = "none";
//     }
//
//     function handleSelection() {
//         let dropzone = document.getElementById("dropzone");
//         dropzone.style.display = "flex";
//         handleFiles(this.getAttribute('data-price-agreement-id'), this.files)
//     }
//
//     function handleFiles(priceAgreementId, files) {
//         document.getElementById("dropzone-icon").classList.remove('fa-upload');
//         document.getElementById("dropzone-icon").classList.add('fa-spinner');
//         document.getElementById("dropzone-icon").classList.add('fa-pulse');
//
//         files = [...files]
//
//         if (files.length > 100) {
//             alert("Je kan niet meer dan 100 bestanden tegelijk uploaden in een map.");
//             hideDropZone();
//             return;
//         }
//
//         // Loop through all files
//         let hasValidFileArray = true;
//         numberOfFiles = files.length;
//         files.forEach(file => {
//             if (file?.size !== null && file?.size  <= 0) {
//                 hideDropZone();
//                 hasValidFileArray = false;
//             }
//         })
//
//         // If file array is invalid we stop the upload
//         if (!hasValidFileArray) {
//             showErrorToast()
//             return;
//         }
//         // Initialize the upload progress bar
//         initializeProgress(files.length)
//         // Loop through the FileList and render image files as thumbnails.
//         files.forEach( (file) => {
//             uploadFile(priceAgreementId, file, files.indexOf(file))
//         });
//     }
//
//     function uploadFile(priceAgreementId, file, i) {
//         let xhr = new XMLHttpRequest()
//         let formData = new FormData()
//         xhr.open('POST', '/api/price-agreements/'+priceAgreementId+'/upload', true)
//         xhr.setRequestHeader('X-CSRF-TOKEN', $('meta[name="csrf-token"]').attr('content'));
//
//         // track upload progress
//         xhr.upload.onprogress = function (event) {
//             if (event.lengthComputable) {
//                 updateProgress(i, (event.loaded * 100.0 / event.total) || 100)
//             }
//         };
//
//         // track completion: both successful or not
//         xhr.onloadend = function () {
//             if (xhr.status === 200) {
//                 finalizeUpload(i)
//             } else {
//                 numberOfFiles = numberOfFiles - 1;
//             }
//         };
//
//         // track completion: both successful or not
//         formData.append('file', file)
//         xhr.send(formData)
//     }
//
//     function initializeProgress(numFiles) {
//         progressBar.style.width = "0%"
//         uploadProgress = []
//         for (let i = numFiles; i > 0; i--) {
//             uploadProgress.push(0)
//         }
//     }
//
//     function updateProgress(fileNumber, percent) {
//         uploadProgress[fileNumber] = percent
//         // Calculate the total progress of the upload(sum of all files)
//         let total = uploadProgress.reduce((tot, curr) => tot + curr, 0) / uploadProgress.length
//         progressBar.style.width = total + "%"
//     }
//
//     function finalizeUpload(fileNumber) {
//         finishedUploads.push(fileNumber)
//
//         if (finishedUploads.length === numberOfFiles) {
//             setTimeout(function () {
//                 location.reload();
//             }, 1000);
//         }
//     }
//
//     function showErrorToast() {
//         /** Custom alert box for incorrect file uploads */
//         window.alert = () => {
//             let target;
//
//             /** Check if event object is available */
//             if (event) {
//                 event.preventDefault();
//                 target = $(event.target);
//             }
//             let modal = $(target ? target.data('confirm-modal') ?? '#js-confirm-modal' : '#js-confirm-modal');
//             modal.find('.modal-body .text').html('Een of meerdere van de geüploade bestanden zijn niet geldig. ' +
//                 'Probeer het opnieuw. <br/><br/>Probeert u direct vanuit een <strong>.zip</strong> of <strong>.rar</strong> bestand te uploaden? ' +
//                 'Pak het <strong>.zip</strong> of <strong>.rar</strong> bestand eerst lokaal uit en upload de uitgepakte bestanden naar Digidos.');
//             modal.find('button').hide();
//             modal.find('button.confirm').show();
//             modal.find('button.confirm').html('Sluiten');
//             modal.find('button.confirm').click(function () {
//                 modal.modal('hide');
//                 setTimeout(function () {
//                     window.location.reload();
//                 }, 200);
//             });
//             modal.modal('show');
//         };
//         alert();
//     }
//
//     $("textarea[name='price_agreement_remark']").on("change", function (e) {
//         const priceAgreementId = $(this).data('price-agreement-id');
//         // Can occur when certain events collide
//         if (this.value === undefined) {
//             return;
//         }
//
//         $.post('/api/price-agreements/'+priceAgreementId+'/update-remark', {
//             remarks: this.value
//         }).done(function (data) {
//             try {
//                 // Find column in table by file id
//                 let inputElement = $('tr[data-file_id="' + fileId + '"]')
//                     .find('input[name="' + column + '"]').html(value);
//                 // Show error message if saving failed
//                 if (data === 'Saved') {
//                     inputElement.removeClass('is-invalid');
//                     return;
//                 }
//                 inputElement.addClass('is-invalid');
//             } catch (e) {
//                 console.log(e);
//             }
//         });
//     });
// });

$(document).ready(function () {
    let uploadProgress = [];
    let finishedUploads = [];
    let numberOfFiles = [];
    let progressBar = document.getElementById('progress-bar');

    // A locked year (see PriceAgreement::isLocked()) still allows uploads, but warns first —
    // window.confirm is overridden by compass (resources/js/components/confirm.js) to show a
    // modal instead of blocking synchronously, so the actual upload happens in the accept callback.
    function withLockConfirmation(form, proceed) {
        if (form.getAttribute('data-locked') !== '1') {
            proceed();
            return;
        }

        confirm(
            'Dit jaar staat op slot voor wijzigingen. Toch een bestand toevoegen?',
            proceed
        );
    }

    // Get all elements with class drag-and-drop-container and add event listeners
    document.querySelectorAll('.drag-and-drop-container').forEach(container => {
        let fileInput = container.querySelector('input[type="file"]');
        let form = container.querySelector('form');

        // Handle file input change event
        fileInput.addEventListener('change', function () {
            let files = this.files;
            withLockConfirmation(form, () => handleFiles(form.getAttribute('data-field-id'), files));
        });

        // Handle drag and drop events
        form.addEventListener('dragover', function (e) {
            e.preventDefault();
            e.stopPropagation();
            form.classList.add('is-dragover');
        });

        form.addEventListener('dragleave', function (e) {
            e.preventDefault();
            e.stopPropagation();
            form.classList.remove('is-dragover');
        });

        form.addEventListener('drop', function (e) {
            e.preventDefault();
            e.stopPropagation();
            form.classList.remove('is-dragover');
            let files = e.dataTransfer.files;
            withLockConfirmation(form, () => handleFiles(form.getAttribute('data-field-id'), files));
        });
    });

    function handleFiles(priceAgreementId, files) {
        document.querySelectorAll('.file-uploading').forEach(element => {
            element.classList.remove('d-none');
        });

        files = [...files];

        if (files.length > 100) {
            alert("Je kan niet meer dan 100 bestanden tegelijk uploaden in een map.");
            return;
        }

        // Loop through all files
        let hasValidFileArray = true;
        numberOfFiles = files.length;
        files.forEach(file => {
            if (file?.size !== null && file?.size <= 0) {
                hasValidFileArray = false;
            }
        });

        // If file array is invalid we stop the upload
        if (!hasValidFileArray) {
            showErrorToast();
            return;
        }
        // Initialize the upload progress bar
        initializeProgress(files.length);
        // Loop through the FileList and render image files as thumbnails.
        files.forEach((file) => {
            uploadFile(priceAgreementId, file, files.indexOf(file));
        });
    }

    function uploadFile(priceAgreementId, file, i) {
        let xhr = new XMLHttpRequest();
        let formData = new FormData();
        xhr.open('POST', '/api/price-agreements/' + priceAgreementId + '/upload', true);
        xhr.setRequestHeader('X-CSRF-TOKEN', $('meta[name="csrf-token"]').attr('content'));

        // track upload progress
        xhr.upload.onprogress = function (event) {
            if (event.lengthComputable) {
                updateProgress(i, (event.loaded * 100.0 / event.total) || 100);
            }
        };

        // track completion: both successful or not
        xhr.onloadend = function () {
            if (xhr.status === 200) {
                finalizeUpload(i);
            } else {
                numberOfFiles = numberOfFiles - 1;
            }
        };

        // track completion: both successful or not
        formData.append('file', file);
        xhr.send(formData);
    }

    function initializeProgress(numFiles) {
        progressBar.style.width = "0%";
        uploadProgress = [];
        for (let i = numFiles; i > 0; i--) {
            uploadProgress.push(0);
        }
    }

    function updateProgress(fileNumber, percent) {
        uploadProgress[fileNumber] = percent;
        // Calculate the total progress of the upload(sum of all files)
        let total = uploadProgress.reduce((tot, curr) => tot + curr, 0) / uploadProgress.length;
        progressBar.style.width = total + "%";
    }

    function finalizeUpload(fileNumber) {
        finishedUploads.push(fileNumber);

        if (finishedUploads.length === numberOfFiles) {
            setTimeout(function () {
                location.reload();
            }, 1000);
        }
    }

    function showErrorToast() {
        /** Custom alert box for incorrect file uploads */
        window.alert = () => {
            let target;

            /** Check if event object is available */
            if (event) {
                event.preventDefault();
                target = $(event.target);
            }
            let modal = $(target ? target.data('confirm-modal') ?? '#js-confirm-modal' : '#js-confirm-modal');
            modal.find('.modal-body .text').html('Een of meerdere van de geüploade bestanden zijn niet geldig. ' +
                'Probeer het opnieuw. <br/><br/>Probeert u direct vanuit een <strong>.zip</strong> of <strong>.rar</strong> bestand te uploaden? ' +
                'Pak het <strong>.zip</strong> of <strong>.rar</strong> bestand eerst lokaal uit en upload de uitgepakte bestanden naar Digidos.');
            modal.find('button').hide();
            modal.find('button.confirm').show();
            modal.find('button.confirm').html('Sluiten');
            modal.find('button.confirm').click(function () {
                modal.modal('hide');
                setTimeout(function () {
                    window.location.reload();
                }, 200);
            });
            modal.modal('show');
        };
        alert();
    }

    $("textarea[name='price_agreement_remark']").on("change", function (e) {
        const priceAgreementId = $(this).data('price-agreement-id');
        // Can occur when certain events collide
        if (this.value === undefined) {
            return;
        }

        withLockConfirmation(this, () => saveGeneralRemark(this, priceAgreementId));
    });

    function saveGeneralRemark(el, priceAgreementId) {
        $.post('/api/price-agreements/' + priceAgreementId + '/update-remark', {
            remarks: el.value
        }).done(function (data) {
            try {
                // Find column in table by file id
                let inputElement = $('tr[data-file_id="' + fileId + '"]')
                    .find('input[name="' + column + '"]').html(value);
                // Show error message if saving failed
                if (data === 'Saved') {
                    inputElement.removeClass('is-invalid');
                    return;
                }
                inputElement.addClass('is-invalid');
            } catch (e) {
                console.log(e);
            }
        });
    }
});
